.productTitle {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.counter {
  padding: 0 6px;
  border-radius: 1000px;
  background: var(--sentiment-background-neutral, rgba(0, 0, 0, 0.08));
}

.loadingSpinnerContainer {
  width: 2rem;
  height: 2rem;
}

.modal {
  max-width: 1000px;
  width: 100%;
}

.modalBody {
  max-height: 75vh;
  overflow-y: scroll;
}